/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForEDPAws extends models.GovernanceConfigurationBaseForEdp {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForEDPAws");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForEDPAws.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForEDPAws>): GovernanceConfigurationForEDPAws {
        let obj = Object.assign(new GovernanceConfigurationForEDPAws(), model);
        GovernanceConfigurationForEDPAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForEDPAws>): GovernanceConfigurationForEDPAws {
        if (!model) return null;
        return GovernanceConfigurationForEDPAws.newInstance(<GovernanceConfigurationForEDPAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForEDPAws) {
        if (!obj) return;

        models.GovernanceConfigurationForEDPAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForEDPAws): boolean {
        if (models.GovernanceConfigurationBaseForEdp.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForEDPAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.commitments) {
            for (let val of this.commitments) {
                models.EdpCommitmentDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Enterprise Discount Program Commitment details for AWS
     */
    commitments: Array<models.EdpCommitmentDetails>;

}
